var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperless(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29.628,
    height: 29.914,
    viewBox: "0 0 29.628 29.914",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2671",
    "data-name": "Rectangle 2671",
    width: 29.628,
    height: 29.914,
    fill: "#1b7934"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1837",
    "data-name": "Group 1837",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1833",
    "data-name": "Group 1833",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14673",
    "data-name": "Path 14673",
    d: "M13.7,6.518a.649.649,0,0,1-.681-.681V3.26A3.131,3.131,0,0,1,13.967.932,3.17,3.17,0,0,1,16.278,0h2.579a.67.67,0,0,1,.492.189.67.67,0,0,1,.189.492V3.258a3.172,3.172,0,0,1-.932,2.313,3.139,3.139,0,0,1-2.328.947ZM5.318,15.949A5.123,5.123,0,0,1,1.554,14.4,5.128,5.128,0,0,1,0,10.633V6.694A1.35,1.35,0,0,1,1.379,5.316H5.318A5.128,5.128,0,0,1,9.082,6.869a5.131,5.131,0,0,1,1.552,3.764V14.57a1.35,1.35,0,0,1-1.379,1.379ZM21.259,29.48a8.136,8.136,0,0,1-2.655-.449,8.784,8.784,0,0,1-2.441-1.309l-1.846,1.848a1.132,1.132,0,0,1-.745.342,1.037,1.037,0,0,1-.8-.321.98.98,0,0,1-.344-.8,1.324,1.324,0,0,1,.344-.809l1.8-1.848a7.834,7.834,0,0,1-1.286-2.4,8.452,8.452,0,0,1-.428-2.655,8.32,8.32,0,0,1,8.388-8.386h6.137a2.238,2.238,0,0,1,2.249,2.253v6.143a8.16,8.16,0,0,1-2.416,5.939,8.028,8.028,0,0,1-5.956,2.453m.344-2.229a5.267,5.267,0,0,0,4.2-1.914,6.874,6.874,0,0,0,1.628-4.6V14.9H20.787a5.408,5.408,0,0,0-4.073,1.7,5.766,5.766,0,0,0-1.63,4.149,6.819,6.819,0,0,0,.268,1.873,6.518,6.518,0,0,0,.838,1.8l3.694-3.566a1.469,1.469,0,0,1,.883-.436,1.038,1.038,0,0,1,.8.352.993.993,0,0,1,.329.817,1.32,1.32,0,0,1-.416.817L17.826,26.1a8.416,8.416,0,0,0,1.755.817,6.275,6.275,0,0,0,2.021.331",
    transform: "translate(0 -0.001)",
    fill: "#1b7934"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperless);
export default __webpack_public_path__ + "static/media/paperless.857fa4c7f931af5a975ea2a6c32bbdba.svg";
export { ForwardRef as ReactComponent };